import { create } from 'zustand'
import { AnimationMixer, Mesh } from 'three';
import { v4 as uuidv4 } from 'uuid';
import { devtools } from 'zustand/middleware'
import { produce } from 'immer';

type Store = {
  isSpeaking: boolean
  sessionId: string;
  currentBot: any;
  isIdle: boolean;
  isMuted: boolean;
  isSpacePressed: boolean;
  isWelcomed: boolean;
  isPlayIndex: number;
  // 解决驱动数字人时竞争问题
  driveDigitalDate: string;
  // 解决问答时竞争问题
  agentLastFetchDate: number;
  // 理论上不应该将不可序列化的数据存到 redux ，这里先暂时这样写
  mixer: AnimationMixer | null,
  morphMeshes: Mesh[], // 用于存储开启了 morphTarget 的 mesh
  setMixer: (mixer: AnimationMixer | null) => void
  setMorphMeshes: (morphMeshes: Mesh[]) => void
  setCurrentBot: (currentBot: any) => void
  update: (fn: (state: Store) => void) => void
}

export const useDigitalStore = create<Store>()(
  devtools(
    (set) => ({
      sessionId: uuidv4(),
      isSpeaking: false,
      isSpacePressed: false,
      driveDigitalDate: '',
      agentLastFetchDate: 0,
      currentBot: {},
      isPlayIndex: 0,
      isIdle: false,
      isMuted: false,
      isWelcomed: false,
      mixer: null,
      morphMeshes: [],
      setMixer: (mixer: AnimationMixer | null) => set({ mixer }),
      setMorphMeshes: (morphMeshes: Mesh[]) => set({ morphMeshes }),
      setCurrentBot: (currentBot: any) => set({ currentBot }),
      update: (fn: (state: Store) => void) => set(produce(fn)),
    }),
    { name: 'digital-store' }
  )
)

export function getDigitalStore() {
  return useDigitalStore.getState()
}
